const CONFIG_URL = `${process.env.BASE_URL || '/'}files-config.json`

let filesCachePromise = null

function loadFilesConfig () {
	if (!filesCachePromise) {
		filesCachePromise = fetch(CONFIG_URL, { cache: 'no-store' })
			.then((res) => {
				if (!res.ok) throw new Error(`files-config: ${res.status}`)
				return res.json()
			})
			.catch(() => [])
	}
	return filesCachePromise
}

export async function getCollect (collect_id) {
	const files = await loadFilesConfig()
	return files.find((item) => item.collect_id == collect_id) || null
}

export function getFileDisplayName (file, index = 0) {
	if (file.display_name) return file.display_name
	if (file.file_name) return file.file_name
	return `文件 ${file.id != null ? file.id : index + 1}`
}

export function isFileAvailable (file, file_path = '') {
	if (file.webUrl) return true
	if (file.file_name && file_path) return true
	return false
}

export function resolveFileUrl (file, file_path = '') {
	if (file.webUrl) return file.webUrl
	if (file.file_name && file_path) return `${file_path}${file.file_name}`
	return ''
}

/** @returns {'pdf'|'word'|'ppt'|'excel'|'file'} */
export function getFileType (file) {
	const candidates = [
		file.file_name,
		file.display_name,
		file.webUrl && decodeURIComponent(String(file.webUrl).split('?')[0]),
	].filter(Boolean)

	let ext = ''
	for (const name of candidates) {
		const match = String(name).match(/\.([a-z0-9]+)$/i)
		if (match) {
			ext = match[1].toLowerCase()
			break
		}
	}

	if (ext === 'pdf') return 'pdf'
	if (ext === 'doc' || ext === 'docx') return 'word'
	if (ext === 'ppt' || ext === 'pptx') return 'ppt'
	if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') return 'excel'
	return 'file'
}

export async function getFileUrl (collect_id, id) {
	const collect = await getCollect(collect_id)
	if (!collect) return ''

	const { file_path, children = [] } = collect
	const file = children.find((item) => item.id == id)
	if (!file) return ''

	return resolveFileUrl(file, file_path)
}
